import { Howl, Howler } from "howler";
import { path } from "../settings";

let engineLoop,
  turtleCrash,
  trafficConeCrash,
  tabChange,
  popUpClose,
  popUpOpen,
  plus,
  play,
  EngineStart,
  EngineCruising,
  minus,
  on,
  off,
  disable,
  CrateCrash,
  CountLoop,
  CountEnd,
  Continue,
  ChickenWinner,
  mainBg,
  chickenSplat,
  chickenFall,
  Meter1,
  Meter2,
  Meter3,
  Meter4,
  Meter5,
  Meter6,
  Meter7,
  enkC,
  enkD,
  mini,
  major,
  mega,
  big,
  oldMan1,
  oldMan2,
  ultra;

let jeepneyLeft = null;
let jeepneyRight = null;
let chickenAmbience = null;
let jeepneyHonking = null;
let jeepneyHonking2 = null;
let jeepReactionPhew2 = null;
let jeepReactionPhew3 = null;
let jeepReactionUmPaa = null;
let jeepReactionWoohoo = null;
let jeepReactionYiepie = null;
let jeepReactionYii = null;
let potHole1 = null;
let potHole2 = null;
let stopSfx = false;
let activeAudio = null;

export function globalVolumes(value) {
  Howler.volume(value);
}

export function stopSFX(flag) {
  const soundsToStop = engineLoop;

  if (flag) {
    stopSfx = flag;

    soundsToStop.stop();
  } else {
    stopSfx = flag;

    soundsToStop.play();
  }
}

export function loadSounds() {
  chickenAmbience = new Howl({
    src: [path.sound + "chickenAmbience.wav"],
    volume: 1,
  });
  oldMan1 = new Howl({
    src: [path.sound + "oldMan1.wav"],
    volume: 1,
  });
  oldMan2 = new Howl({
    src: [path.sound + "oldMan2.wav"],
    volume: 1,
  });
  jeepneyHonking = new Howl({
    src: [path.sound + "jeepneyHonking.wav"],
    volume: 1,
  });
  jeepneyHonking2 = new Howl({
    src: [path.sound + "jeepneyHonking2.wav"],
    volume: 1,
  });
  jeepReactionPhew2 = new Howl({
    src: [path.sound + "jeepReactionPhew2.mp3"],
    volume: 1,
  });
  jeepReactionPhew3 = new Howl({
    src: [path.sound + "jeepReactionPhew3.mp3"],
    volume: 1,
  });
  jeepReactionUmPaa = new Howl({
    src: [path.sound + "jeepReactionUmPaa.mp3"],
    volume: 1,
  });
  jeepReactionWoohoo = new Howl({
    src: [path.sound + "jeepReactionWoohoo.mp3"],
    volume: 1,
  });
  jeepReactionYiepie = new Howl({
    src: [path.sound + "jeepReactionYiepie.mp3"],
    volume: 1,
  });
  jeepReactionYii = new Howl({
    src: [path.sound + "jeepReactionYii.mp3"],
    volume: 1,
  });
  potHole1 = new Howl({
    src: [path.sound + "potHole1.wav"],
    volume: 1,
  });
  potHole2 = new Howl({
    src: [path.sound + "potHole2.wav"],
    volume: 1,
  });
  jeepneyLeft = new Howl({
    src: [path.sound + "jeepneyLeft.wav"],
    volume: 1,
  });
  jeepneyRight = new Howl({
    src: [path.sound + "jeepneyRight.wav"],
    volume: 1,
  });

  mainBg = new Howl({
    src: [path.sound + "mainBg.mp3"],
    loop: true,
    volume: 0.2,
  });
  chickenFall = new Howl({
    src: [path.sound + "ChickenFall.wav"],
    volume: 1,
  });
  chickenSplat = new Howl({
    src: [path.sound + "ChickenSplat.wav"],
    volume: 1,
  });
  engineLoop = new Howl({
    src: [path.sound + "EngineLoop.wav"],
    loop: true,
    volume: 0.1,
  });
  turtleCrash = new Howl({
    src: [path.sound + "TurtleCrash.wav"],
    volume: 1,
  });
  trafficConeCrash = new Howl({
    src: [path.sound + "TrafficConeCrash.wav"],
    volume: 1,
  });
  tabChange = new Howl({
    src: [path.sound + "tabChange.wav"],
    volume: 1,
  });
  popUpOpen = new Howl({
    src: [path.sound + "popUpOpen.wav"],
    volume: 1,
  });
  popUpClose = new Howl({
    src: [path.sound + "popUpClose.wav"],
    volume: 1,
  });
  plus = new Howl({
    src: [path.sound + "plus.wav"],
    volume: 1,
  });
  play = new Howl({
    src: [path.sound + "play.wav"],
    volume: 1,
  });
  EngineStart = new Howl({
    src: [path.sound + "EngineStart.wav"],
    volume: 0.1,
    onend: afterStart,
  });
  EngineCruising = new Howl({
    src: [path.sound + "EngineCruising.wav"],
    volume: 0.1,
    loop: true,
  });
  minus = new Howl({
    src: [path.sound + "minus.wav"],
    volume: 1,
  });
  on = new Howl({
    src: [path.sound + "on.wav"],
    volume: 1,
  });
  off = new Howl({
    src: [path.sound + "off.wav"],
    volume: 1,
  });
  disable = new Howl({
    src: [path.sound + "disable.wav"],
    volume: 1,
  });
  CrateCrash = new Howl({
    src: [path.sound + "CrateCrash.wav"],
    volume: 1,
  });
  CountLoop = new Howl({
    src: [path.sound + "CountLoop.wav"],
    volume: 1,
  });
  CountEnd = new Howl({
    src: [path.sound + "CountEnd.wav"],
    volume: 1,
  });
  Continue = new Howl({
    src: [path.sound + "Continue.wav"],
    volume: 1,
  });
  ChickenWinner = new Howl({
    src: [path.sound + "ChickenWinner.wav"],
    volume: 1,
  });
  Meter1 = new Howl({
    src: [path.sound + "meter1.wav"],
    volume: 1,
  });
  Meter2 = new Howl({
    src: [path.sound + "meter2.wav"],
    volume: 1,
  });
  Meter3 = new Howl({
    src: [path.sound + "meter3.wav"],
    volume: 1,
  });
  Meter4 = new Howl({
    src: [path.sound + "meter4.wav"],
    volume: 1,
  });
  Meter5 = new Howl({
    src: [path.sound + "meter5.wav"],
    volume: 1,
  });
  Meter6 = new Howl({
    src: [path.sound + "meter6.wav"],
    volume: 1,
  });
  Meter7 = new Howl({
    src: [path.sound + "meter7.wav"],
    volume: 1,
  });

  enkC = new Howl({
    src: [path.victoryPath + "Victory-Enk-C.mp3"],
    volume: 1,
  });

  enkD = new Howl({
    src: [path.victoryPath + "Victory-Enk-D.mp3"],
    volume: 1,
  });

  mini = new Howl({
    src: [path.victoryPath + "Victory-Mini-win-Final.mp3"],
    volume: 1,
  });

  major = new Howl({
    src: [path.victoryPath + "Victory-Mega-win-Final.mp3"],
    volume: 1,
  });

  mega = new Howl({
    src: [path.sound + "Bigwin-Megawin.mp3"],
    volume: 1,
  });

  big = new Howl({
    src: [path.sound + "Bigwin.mp3"],
    volume: 1,
  });

  ultra = new Howl({
    src: [path.sound + "Bigwin-Megawin-Ultrawin.mp3"],
    volume: 1,
  });
}

export function playPotHole2() {
  if (!stopSfx) potHole2?.play();
}
export function playPotHole1() {
  if (!stopSfx) potHole1?.play();
}
export function playJeepReactionYii() {
  if (!stopSfx) jeepReactionYii?.play();
}
export function playJeepReactionYiepie() {
  if (!stopSfx) jeepReactionYiepie?.play();
}
export function playJeepReactionWoohoo() {
  if (!stopSfx) jeepReactionWoohoo?.play();
}
export function playJeepReactionUmPaa() {
  if (!stopSfx) jeepReactionUmPaa?.play();
}
export function playJeepReactionPhew3() {
  if (!stopSfx) jeepReactionPhew3?.play();
}
export function playJeepReactionPhew2() {
  if (!stopSfx) jeepReactionPhew2?.play();
}
export function playJeepneyHonking2() {
  if (!stopSfx) jeepneyHonking2?.play();
}
export function playJeepneyHonking() {
  if (!stopSfx) jeepneyHonking?.play();
}
export function playChickenAmbience() {
  if (!stopSfx) chickenAmbience?.play();
}
export function playOldMan1() {
  if (!stopSfx) oldMan1?.play();
}
export function playOldMan2() {
  if (!stopSfx) oldMan2?.play();
}

export function playJeepneyLeft() {
  if (!stopSfx) jeepneyLeft?.play();
}
export function playJeepneyRight() {
  if (!stopSfx) jeepneyRight?.play();
}
export function playPopUpClose() {
  if (!stopSfx) popUpClose?.play();
}

export function playMainBg() {
  if (mainBg) mainBg.play();
}

export function stopMainBg() {
  if (mainBg) mainBg.stop();
}

export function playChickenFall() {
  if (!stopSfx && chickenFall) chickenFall.play();
}

export function PlayChickenSplat() {
  if (!stopSfx && chickenSplat) chickenSplat.play();
}
function afterStart() {
  if (!stopSfx && engineLoop) engineLoop.play();
}

export function playEngineLoop() {
  if (!stopSfx) EngineStart?.play();
}
export function playEngineCruising() {
  if (!stopSfx) EngineCruising?.play();
}
export function playTurtleCrash() {
  if (!stopSfx) turtleCrash?.play();
}
export function playTrafficConeCrash() {
  if (!stopSfx) trafficConeCrash?.play();
}
export function playtabChange() {
  if (!stopSfx) tabChange?.play();
}
export function playPopUpOpen() {
  if (!stopSfx) popUpOpen?.play();
}
export function playPlus() {
  if (!stopSfx) plus?.play();
}
export function playPlay() {
  if (!stopSfx) play?.play();
}
export function playEngineStart() {
  if (!stopSfx) EngineStart?.play();
}
export function playMinus() {
  if (!stopSfx) minus?.play();
}
export function playOn() {
  if (!stopSfx) on?.play();
}
export function playOff() {
  if (!stopSfx) off?.play();
}
export function playDisable() {
  if (!stopSfx) disable?.play();
}
export function playCrateCrash() {
  if (!stopSfx) CrateCrash?.play();
}

export function playCountLoop() {
  if (!stopSfx) CountLoop?.play();
}
export function playCountEnd() {
  if (!stopSfx) CountEnd?.play();
}
export function playContinue() {
  if (!stopSfx) Continue?.play();
}
export function playChickenWinner() {
  if (!stopSfx) ChickenWinner?.play();
}
export function playMeter1() {
  if (!stopSfx) Meter1?.play();
}
export function playMeter2() {
  if (!stopSfx) Meter2?.play();
}
export function playMeter3() {
  if (!stopSfx) Meter3?.play();
}
export function playMeter4() {
  if (!stopSfx) Meter4?.play();
}
export function playMeter5() {
  if (!stopSfx) Meter5?.play();
}
export function playMeter6() {
  if (!stopSfx) Meter6?.play();
}
export function playMeter7() {
  if (!stopSfx) Meter7?.play();
}

export function playEnkCAudio() {
  playSound(enkC);
}

export function playEnkDAudio() {
  playSound(enkD);
}

export function playMiniAudio() {
  playSound(mini);
}

export function playMajorAudio(){
  playSound(major)
}

export function playMegaAudio() {
  playSound(mega);
}

export function playBigAudio() {
  playSound(big);
}

export function playUltraAudio() {
  playSound(ultra);
}

const playSound = (sound) => {
  if (sound && !stopSfx){
    activeAudio = sound
    sound.play();
  }
    
  else return console.error(`Error playing sound: ${sound}`);
};

export const stopActiveSound = () => {
  if (activeAudio) {
    activeAudio.stop();
    activeAudio = null;
  }
};